<template>
    <div class="p-4 px-3 border-r bg-white h-full">
        <div class="px-3 mb-8 w-full">
            <div class="flex flex-col items-center justify-center px-2 py-5 border border-dashed border-gray-300 rounded-xl">
                <RouterLink to="#" class="w-20 h-20 mb-3 rounded-full border-2 border-gray-300">
                    <img :src="profile.image" alt="avatar" class=" w-full h-full object-cover rounded-full">
                </RouterLink>
                <h3 class="font-lead text-lg font-medium text-center mb-0.5">{{ profile.name }}</h3>
                <p class="text-center text-text text-xs" v-if="profile.email">{{ profile.email }}</p>
                <p class="text-center text-text text-xs" v-if="profile.phone">{{ profile.country_code }}{{ profile.phone }}</p>
            </div>
        </div>
        <nav class="flex flex-col my-3 py-4 border-t border-gray-200 border-b">
            <router-link
                class="profile-link font-medium text-sm leading-5 flex items-center gap-3 capitalize py-3 px-4 group hover:text-primary transition-all duration-500"
                :to="{ name: 'frontend.account.overview' }">
                <i
                    class="lab lab-fill-dashboard text-[#A0A3BD] group-hover:text-primary transition-all duration-500"></i>
                <span>{{ $t('menu.overview') }}</span>
            </router-link>

            <router-link
                class="profile-link font-medium text-sm leading-5 flex items-center gap-3 capitalize py-3 px-4 group hover:text-primary transition-all duration-500"
                :to="{ name: 'frontend.account.orderHistory' }">
                <i class="lab lab-fill-bag text-[#A0A3BD] group-hover:text-primary transition-all duration-500"></i>
                <span>{{ $t('menu.order_history') }}</span>
            </router-link>

            <router-link
                class="profile-link font-medium text-sm leading-5 flex items-center gap-3 capitalize py-3 px-4 group hover:text-primary transition-all duration-500"
                :to="{ name: 'frontend.account.returnOrders' }">
                <i class="lab lab-fill-refresh text-[#A0A3BD] group-hover:text-primary transition-all duration-500"></i>
                <span>{{ $t('menu.return_orders') }}</span>
            </router-link>

            <router-link
                class="profile-link font-medium text-sm leading-5 flex items-center gap-3 capitalize py-3 px-4 group hover:text-primary transition-all duration-500"
                :to="{ name: 'frontend.account.accountInfo' }">
                <i class="lab lab-fill-user text-[#A0A3BD] group-hover:text-primary transition-all duration-500"></i>
                <span>{{ $t('menu.account_info') }}</span>
            </router-link>

            <router-link
                class="profile-link font-medium text-sm leading-5 flex items-center gap-3 capitalize py-3 px-4 group hover:text-primary transition-all duration-500"
                :to="{ name: 'frontend.account.changePassword' }">
                <i class="lab lab-fill-key text-[#A0A3BD] group-hover:text-primary transition-all duration-500"></i>
                <span>{{ $t('menu.change_password') }}</span>
            </router-link>

            <router-link
                class="profile-link font-medium text-sm leading-5 flex items-center gap-3 capitalize py-3 px-4 group hover:text-primary transition-all duration-500"
                :to="{ name: 'frontend.account.address' }">
                <i
                    class="lab lab-fill-location text-[#A0A3BD] group-hover:text-primary transition-all duration-500"></i>
                <span>{{ $t('menu.addresses') }}</span>
            </router-link>
        </nav>
    </div>
</template>

<script>
export default {
    name: "AccountMenuComponent",
    data() {
        return {
            image: "",
            name: "",
            phone: "",
        };
    },
    computed: {
        profile: function () {
            return this.$store.getters.authInfo;
        },
    }
};
</script>